import React, { useState, useCallback, useContext } from "react"
import Img from "gatsby-image"

import { CartContext } from "../context/CartContext"
import { LocationContext } from "../context/LocationContext"
import { ContactContext } from "../context/ContactContext"

import ChooseLocation from "../components/chooseLocation"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Loader from "../components/loader"

import {
  cartTotal,
  displayPrice,
  validateEmail,
} from "@antoine-lb/business-logic"

import styled from "styled-components"

function titleCase(str) {
  var splitStr = str.toLowerCase().split(" ")
  for (var i = 0; i < splitStr.length; i++) {
    // You do not need to check if i is larger than splitStr length, as your for does that for you
    // Assign it back to the array
    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1)
  }
  // Directly return the joined string
  return splitStr.join(" ")
}

const CheckoutWrapper = styled.form`
  margin-top: 30px;
  legend {
    margin-top: 35px;
    font-size: 25px;
  }

  fieldset {
    border: 1px solid #ddd;
  }
  @media only screen and (max-width: 500px) {
    /* legend {
      margin-top: 35px;
      font-size: 25px;
    } */
    p {
      font-size: 16px;
    }
  }
`

const Product = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
  width: 100%;
  span {
    font-size: 15px;
  }

  .product-buttons {
    display: flex;
    flex-direction: column;
  }
`

const ProductQtyButton = styled.button`
  padding: 10px;
  margin-top: 2px;
  width: 30px;
  background: #732619;
  font: 400 18px Marcellus, sans-serif;
  color: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  border: none;
  cursor: pointer;
  :active {
    background: #732619cc;
  }

  @media only screen and (max-width: 500px) {
    font-size: 16px;
    padding: 2px 5px;
  }
`
const ProductImg = styled.div`
  position: relative;
  width: 100px;
  height: 100px;
  margin-right: 8px;

  @media only screen and (max-width: 500px) {
    width: 60px;
    height: 60px;
  }
`

const ContactForm = styled.div`
  span {
    font-size: 20px;
  }
`
const ContactFormField = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  input {
    margin-top: 5px;
    padding: 6px;
    padding-left: 15px;
    height: 35px;
    /* width: 60%; */
    border: none;
    font-size: 17px;
    font: 400 18px Marcellus, sans-serif;
    -webkit-appearance: none;
    border-radius: 1px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    -moz-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12),
      0 1px 2px rgba(0, 0, 0, 0.24);
    -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12),
      0 1px 2px rgba(0, 0, 0, 0.24);
  }

  label {
    width: 100%;
    display: flex;
    flex-direction: column;
    input {
      /* width: 100%; */
    }
    div {
      display: flex;
      align-items: center;
      span {
        font-size: 17px;
      }
      input {
        flex-grow: 1;
        margin-left: 8px;
      }
    }
  }

  @media only screen and (max-width: 500px) {
    span,
    input {
      font-size: 17px;
    }
  }
`

const SubmitButton = styled.button`
  padding: 15px;
  width: 100%;
  text-align: center;
  margin-top: 20px;
  background: #732619;
  font: 400 18px Marcellus, sans-serif;
  color: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  border: none;
  cursor: pointer;
  :active,
  :disabled {
    background: #732619cc;
  }

  :disabled {
    cursor: unset;
  }

  @media only screen and (max-width: 500px) {
    font-size: 15px;
    padding: 10px;
  }
`

const PrecioTotal = styled.div`
  margin-top: 40px;
  /* max-width: 300px; */
  p {
    margin: 0;
  }

  .precio-total {
    margin-top: 8px;
    font-size: 18px;
  }
`

const DatosTransferencias = styled.footer`
  margin-top: 70px;
  /* max-width: 300px; */
  p {
    margin: 0;
  }
`

const ProductsInCart = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
`

export default () => {
  const {
    customerName,
    customerPhone,
    customerEmail,
    setCustomerName,
    setCustomerPhone,
    setCustomerEmail,
  } = useContext(ContactContext)

  const { cart, addToCart, clearCart } = useContext(CartContext)
  const { location, isLocationValid, deliveryZone, isTakeaway } = useContext(
    LocationContext
  )
  const [, setSuccess] = useState(null)
  const [errorMessage, setErrorMessage] = useState("")
  const [successMessage, setSuccessMessage] = useState("")

  const [, updateState] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const forceUpdate = useCallback(() => updateState({}), [])

  const submitCart = async () => {
    let delivery_price_in_cent = 0

    if (!isTakeaway && deliveryZone !== undefined) {
      delivery_price_in_cent = deliveryZone.price_in_cent
    }

    setIsLoading(true)
    const data = {
      cart,
      location: {
        ...location,
        notes: `${location.hour} ${location.date} - ${location.notes}`,
      },
      total_price_before_shipping_in_cent: cartTotal(cart),
      delivery_price_in_cent,
      customer: {
        name: titleCase(customerName),
        phone: "+569" + customerPhone,
        email: customerEmail,
      },
      rest: "baco-cl",
    }

    await fetch(`${process.env.BACKEND_URL}/orders`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then(async response => {
        console.log("response", response)

        if (response.ok) {
          const order = await response.json()

          setSuccess(true)

          setIsLoading(false)
          setErrorMessage("")
          console.log("order", order)
          setSuccessMessage(
            `Comanda #${
              order.id
            } recibida, sera contactado/a por Whatsapp para validar su comanda (precio total de la comanda $${displayPrice(
              parseInt(order.total_price_before_shipping_in_cent) +
                parseInt(order.delivery_price_in_cent)
            )})`
          )
          clearCart()
        } else {
          const errorText = await response.text()
          console.error("errorText", errorText)
          setIsLoading(false)
          setErrorMessage(
            `Un error a ocurrido, contacte +569 59157833 para pasar su comanda [${errorText}]`
          )
          setSuccessMessage("")
        }
      })
      .catch(err => {
        setIsLoading(false)
        console.error(".catch err = ", err)
        setErrorMessage(
          "Un error a ocurrido, contacte +569 59157833 para pasar su comanda"
        )
        setSuccessMessage("")
      })
  }

  let canSubmit = false
  if (
    isLocationValid &&
    cart.length !== 0 &&
    customerName.length !== 0 &&
    customerPhone.length !== 0 &&
    validateEmail(customerEmail)
  )
    canSubmit = true

  // TODO: Make a form
  return (
    <Layout>
      <SEO title="Cart" />
      {successMessage.length !== 0 ? (
        <DatosTransferencias>
          <h2>{successMessage}</h2>
          <h3>Datos de Transferencias</h3>
          <p>
            Nombre: <strong>BACO</strong>
          </p>
          <p>
            Rut: <strong>76.278.620-6</strong>
          </p>
          <p>
            Banco: <strong>SECURITY</strong>
          </p>
          <p>
            Nº CC: <strong>49703701</strong>
          </p>
          <p>
            Mail: <strong>pagobaco@gmail.com</strong>
          </p>
        </DatosTransferencias>
      ) : (
        <CheckoutWrapper>
          <fieldset>
            <legend>Carro</legend>
            {cart.map(product => (
              <Product key={product.product_id}>
                <ProductImg>
                  {product.thumbnail ? (
                    <Img
                      fluid={product.thumbnail.childImageSharp.fluid}
                      style={{
                        boxShadow:
                          "0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)",
                        borderRadius: "4px",

                        position: "absolute",
                        left: 0,
                        top: 0,
                        width: "100%",
                        height: "100%",
                      }}
                    />
                  ) : null}
                </ProductImg>
                <ProductsInCart>
                  <span>
                    <strong>{product.qty} </strong> {product.name} = $
                    {displayPrice(product.price_in_cent * product.qty)}
                  </span>
                </ProductsInCart>
                <div className="product-buttons">
                  <ProductQtyButton
                    type="button"
                    onClick={() => {
                      addToCart(product, 1)
                      forceUpdate()
                    }}
                  >
                    +
                  </ProductQtyButton>
                  <ProductQtyButton
                    type="button"
                    onClick={() => {
                      addToCart(product, -1)
                      forceUpdate()
                    }}
                  >
                    -
                  </ProductQtyButton>
                </div>
              </Product>
            ))}
            <br />
            <p>
              <strong>Subtotal: ${displayPrice(cartTotal(cart))}</strong>
            </p>
            <p>Los despachos se pagan solo con transferencia.</p>
          </fieldset>
          <fieldset>
            <legend>Informacion de Contacto</legend>
            <ContactForm>
              <ContactFormField>
                <label>
                  Nombre:
                  <input
                    type="text"
                    value={customerName}
                    style={{ textTransform: "capitalize" }}
                    onChange={event => setCustomerName(event.target.value)}
                  />
                </label>
              </ContactFormField>
              <ContactFormField>
                <label>
                  Numero de telefono:
                  <div>
                    <span>+569</span>
                    <input
                      type="tel"
                      value={customerPhone}
                      onChange={event => setCustomerPhone(event.target.value)}
                    />
                  </div>
                </label>
              </ContactFormField>
              <ContactFormField>
                <label>
                  Email:
                  <input
                    type="email"
                    value={customerEmail}
                    onChange={event => setCustomerEmail(event.target.value)}
                  />
                </label>
              </ContactFormField>
            </ContactForm>
            <ChooseLocation />
          </fieldset>
          <PrecioTotal>
            <p>Subtotal: ${displayPrice(cartTotal(cart))}</p>
            {deliveryZone ? (
              <p>Despacho: ${displayPrice(deliveryZone.price_in_cent)}</p>
            ) : null}
            {deliveryZone ? (
              <p className="precio-total">
                <strong>Total a pagar:</strong> $
                {displayPrice(deliveryZone.price_in_cent + cartTotal(cart))}
              </p>
            ) : null}
          </PrecioTotal>
          {isLoading ? (
            <Loader />
          ) : (
            <>
              <SubmitButton disabled={!canSubmit} onClick={submitCart}>
                Pasar Comanda y Pagar
              </SubmitButton>
              {!canSubmit ? (
                <ul>
                  <strong>Falta:</strong>
                  {customerName.length === 0 ? <li>Nombre</li> : null}
                  {customerPhone.length === 0 ? <li>Numero</li> : null}
                  {!validateEmail(customerEmail) ? <li>Email valido</li> : null}
                  {!isLocationValid ? <li>Una direccion valida </li> : null}
                  {cart.length === 0 ? <li>Elementos en el carro</li> : null}
                </ul>
              ) : null}
            </>
          )}
          {errorMessage.length !== 0 ? <span>{errorMessage}</span> : null}
        </CheckoutWrapper>
      )}
      <br />
      <br />
      <br />
      <br />
      <br />
    </Layout>
  )
}
